$('.js-trigger-validate form').validate({
    rules: {
        userEmail: {
            email: true,
            required: true
        },
        new_pass: "required",
        new_pass_confirm: {
            equalTo: "#password"
        }
    }
});


/* Show hide pass */
$(".input-showhide").find('.pass-status').on('click', function (event) {
    event.preventDefault();

    if ($(this).hasClass('is-hidden')) {
        $(this).removeClass('is-hidden').addClass('is-visible');
        $(this).siblings('input').attr('type', 'password');
    }
    else {
        $(this).removeClass('is-visible').addClass('is-hidden');
        $(this).siblings('input').attr('type', 'text');
    }
});